import type { Components, Theme } from '@mui/material';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.spacing(1.5),
      marginTop: theme.spacing(0.5),
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
    }),
  },
};
